import { useEffect } from "react"

import Grid from "@material-ui/core/Grid"

function MaintenanceFallback(props) {
  const { backgroundProcessor, setAppBarTitle } = props

  useEffect(() => {
    setAppBarTitle("Maintenance")

    if (backgroundProcessor?.tasks) backgroundProcessor?.reset()
  }, [])

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      style={{ paddingBottom: "1rem" }}
    >
      <Grid
        container
        item
        direction="column"
        alignItems="center"
        style={{ paddingBottom: "1rem", paddingTop: "2rem" }}
      >
        <Grid item>
          <h1>Maintenance</h1>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default MaintenanceFallback
